import { render, staticRenderFns } from "./AuthorAvatar.vue?vue&type=template&id=f3962354&scoped=true&"
import script from "./AuthorAvatar.vue?vue&type=script&lang=js&"
export * from "./AuthorAvatar.vue?vue&type=script&lang=js&"
import style0 from "./AuthorAvatar.vue?vue&type=style&index=0&id=f3962354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3962354",
  null
  
)

export default component.exports